import { render, staticRenderFns } from "./SignBlock.vue?vue&type=template&id=271b26d2"
import script from "./SignBlock.vue?vue&type=script&lang=js"
export * from "./SignBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QBtn,QBtnDropdown,QList,QItem,QItemSection,QItemLabel,QField,QDialog,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBtn,QBtnDropdown,QList,QItem,QItemSection,QItemLabel,QField,QDialog})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
